<template>
  <div class="terms-of-use-page">
    <div class="terms-of-use-page__title">
      <p class="terms-of-use-page__title-text">Для доступа в систему ознакомтесь с условиями проведения торгов</p>
    </div>

    <div class="terms-of-use-page__content">
      <div class="terms-of-use-page-wrapper">
        <terms-of-use-content />
      </div>
    </div>

    <div class="terms-of-use-page__actions">
      <mts-button v-on:click="submit">Я принимаю условия проведения торгов</mts-button>
    </div>
  </div>
</template>

<script>
  import TermsOfUseContent from './TermsOfUseContent';

  export default {
    name: 'TermsOfUsePage',
    components: {
      TermsOfUseContent
    },
    methods: {
      submit() {
        this.$emit('submit');
      }
    }
  };
</script>

<style>
  .terms-of-use-page__title {}
  .terms-of-use-page__title-text {
    font-family: 'MTSSansWebRegular';
    font-size: 16px;
    line-height: 20px;
  }

  .terms-of-use-page-wrapper {
    margin: 14px 12px;
  }

  .terms-of-use-page__content {
    margin-top: 20px;
    border-radius: var(--base-radius);
    border: 2px solid var(--color-link-water);
    height: 430px;
    overflow-y: scroll;
  }

  .terms-of-use-page__content-text {
    font-family: 'MTSSansWebRegular';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-bottom: 8px;
  }

  .terms-of-use-page__content-title {
    font-family: 'MTSSansWebMedium';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .terms-of-use-page__content-list {
    margin-top: 0;
  }

  .terms-of-use-page__content-list li {
    font-family: 'MTSSansWebRegular';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-bottom: 8px;
  }

  .terms-of-use-page__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
</style>
